import { render } from "./ReadyToHelpYou.vue?vue&type=template&id=3dc57091"
import script from "./ReadyToHelpYou.vue?vue&type=script&lang=js"
export * from "./ReadyToHelpYou.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__